export const getTime = (time: string) => {
    if (time) {
        const timesFilter = time.split(' ')[1].split(':');
        return `${timesFilter[0]}h${timesFilter[1]}`;
    }
};
